// NEXT_PUBLIC_* env vars are inlined by Next.js at build time. They must be
// accessed via literal property notation (process.env.NAME, not
// process.env[name]) for inlining to work, so the helper takes the value as a
// parameter rather than re-reading it from a dynamic key.
function requireEnv(name: string, value: string | undefined): string {
  if (!value) {
    throw new Error(`Missing required environment variable: ${name}`)
  }
  return value
}

export const API_ROOT_URL = requireEnv("NEXT_PUBLIC_PORTAL_BACKEND_URL", process.env.NEXT_PUBLIC_PORTAL_BACKEND_URL)
export const SELF_RECORDING_APP_URL = process.env.NEXT_PUBLIC_SELF_RECORDING_APP_URL ?? ""
